<div>
  <app-spinner></app-spinner>

  @if (data?.message; as message) {
    <app-spacer [mobile]="12" [desktop]="12"></app-spacer>
    <app-title weight="500" size="small">
      <p>
        {{ message }}
      </p>
    </app-title>
  }
</div>
